<template>
  <div class="card-customer-fields">
    <div class="mt-2 mb-4">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>

    <div class="mb-2">
      <vs-input
        class="w-full"
        label="Nome Completo"
        placeholder="Nome Completo"
        :value="fullName"
        @input="onFullNameInput"
      />
    </div>

    <WhatsAppPhoneInput :basket="basket" />

    <div class="mb-2">
      <vs-input
        class="w-full"
        label="CPF/CNPJ do Titular do Cartão"
        placeholder="Somente números"
        v-model="basket.cpfcnpj"
      />
    </div>

    <div class="mb-2 mt-6">
      <strong>Endereço de Cobrança do Titular do Cartão</strong>
    </div>
    <div class="mt-2 mb-4">
      O endereço de cobrança tem que ser o mesmo endereço que está cadastro no banco ou operadora de cartão de crédito.
    </div>

    <div class="mb-2">
      <div class="flex">
        <div class="w-6/12 mr-0 md:mr-4">
          <vs-select label="País" v-model="basket.address_country" class="w-full">
            <vs-select-item
              :key="country.iso"
              :value="country.iso"
              :text="country.nome"
              v-for="country in countries"
            />
          </vs-select>
        </div>
        <div class="w-6/12">
          <vs-input
            class="w-full"
            label="CEP"
            placeholder="CEP"
            v-model="basket.address_postcode"
            @input="checkCep"
            required
          />
        </div>
      </div>
    </div>

    <div class="mb-2">
      <div class="flex">
        <div class="w-4/5 mr-4">
          <vs-input
            class="w-full"
            label="Rua, Avenida"
            placeholder="Rua, Avenida"
            v-model="basket.address_street"
            required
          />
        </div>
        <div class="w-1/5">
          <vs-input
            class="w-full"
            label="Número"
            placeholder="Número"
            v-model="basket.address_number"
            required
          />
        </div>
      </div>
    </div>

    <div class="mb-2">
      <div class="flex">
        <div class="w-2/5 mr-4">
          <vs-input
            class="w-full"
            label="Bairro"
            placeholder="Bairro"
            v-model="basket.address_complement"
          />
        </div>
        <div class="w-2/5 mr-4">
          <vs-input
            class="w-full"
            label="Cidade"
            placeholder="Cidade"
            v-model="basket.address_city"
            required
          />
        </div>
        <div class="w-1/5">
          <vs-input
            class="w-full"
            label="Estado"
            placeholder="UF"
            v-model="basket.address_state"
            required
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WhatsAppPhoneInput from './WhatsAppPhoneInput.vue';
import { checkoutLog } from '../utils/checkoutDebug';

export default {
  name: 'CreditCardCustomerFields',
  components: {
    WhatsAppPhoneInput
  },
  props: {
    basket: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      countries: []
    };
  },
  computed: {
    fullName() {
      if (this.basket.name) {
        return this.basket.name;
      }
      return [this.basket.firstname, this.basket.lastname].filter(Boolean).join(' ').trim();
    }
  },
  mounted() {
    checkoutLog('form:customer-fields-mounted', {}, this.$route);
    if (!this.basket.address_country) {
      this.$set(this.basket, 'address_country', 'br');
    }
    this.$api.get('/assets/countries.json?v1').then(response => {
      this.countries = response.data;
      checkoutLog('form:countries-loaded', { count: this.countries.length }, this.$route);
    });
    this.syncNameParts();
  },
  methods: {
    onFullNameInput(value) {
      this.$set(this.basket, 'name', value);
      this.syncNameParts(value);
    },
    syncNameParts(value) {
      const name = String(value != null ? value : this.basket.name || '').trim();
      if (!name) {
        return;
      }
      const parts = name.split(/\s+/);
      this.$set(this.basket, 'firstname', parts[0] || '');
      this.$set(this.basket, 'lastname', parts.slice(1).join(' ') || parts[0] || '');
    },
    checkCep() {
      const cep = String(this.basket.address_postcode || '').replace(/[^0-9]/g, '');
      if (cep.length === 8) {
        this.$api
          .post('/api/v1/checkout/cep', { cep })
          .then(response => {
            if (response.data && response.data.logradouro) {
              this.basket.address_street = response.data.logradouro;
              this.basket.address_city = response.data.cidade;
              this.basket.address_complement = response.data.bairro;
              this.basket.address_state = response.data.estado;
            }
          });
      }
    }
  }
};
</script>
